import { CustomNoRowsOverlayProps } from "@ag-grid-community/react";
import { BodyMedium, BodySmall, Box, Button } from "@parspec/pixel";
import ImportProducts from "../../shared/ImportProducts";

interface NoRowsOverlayProps extends CustomNoRowsOverlayProps {
    goToSectionView: () => void;
};

const sxStyles = {
    container: {
        position: 'absolute',
        top: 33,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: "column",
        alignItems: 'center',
        justifyContent: 'center',
        gap: "16px",
        backgroundColor: 'neutral.light',
        zIndex: 10,
        pointerEvents: "all"
    },
    description: {
        lineHeight: "1.25rem",
    },
    btn: { bgColor: "white" },
}

export const ManufacturerViewNoOverlay = (props: NoRowsOverlayProps) => {
    const { goToSectionView } = props;
    return (
        <Box sx={sxStyles.container}>
            <img src={'assets/images/NoData/NoData.svg'} alt="No-Data" height={100} />
            <Box>
                <BodyMedium fontWeight={700}>Looking a little empty!</BodyMedium>
                <Box width="600px" mt={1}>
                    <BodySmall sx={sxStyles.description}>
                        To get started, add products manually from the Section view or let us do the
                    </BodySmall>
                    <BodySmall sx={sxStyles.description}>
                        heavy lifting by importing a schedule, quote, Parspec BOM, or submittal.
                    </BodySmall>
                </Box>
            </Box>
            <Box display="flex" gap={2}>
                <Button
                    color="secondary"
                    variant="outlined"
                    sx={sxStyles.btn}
                    onClick={goToSectionView}
                >
                    Back to Section View
                </Button>
                <ImportProducts />
            </Box>

        </Box>
    );
};